export const SET_NUMBER_BILLINGS = 'SET_NUMBER_BILLINGS'
export const RESET_NUMBER_BILLINGS = 'RESET_NUMBER_BILLINGS'
